import React, { useState, useEffect, useRef } from 'react';
import { Card } from 'primereact/card';
import { MultiSelect } from 'primereact/multiselect';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import axios from '../../utils/axios';
import { dashboardFilterData, dashboardReports, dashboardLeads, syncLocations, syncLocations_v2 } from '../../utils/urls';
import './dashboard.css'
import { useSelector } from 'react-redux'
import LeadsTable from '../leads/LeadsTable'
import { Calendar } from 'primereact/calendar';
import ChartJs from '../Chart/Chart';
import FlexComponent from '../FlexComponent';
import { Avatar } from 'primereact/avatar';
import AppModal from '../../shared/AppModal';
import AppsTable from '../apps/appsTable';
import RepliesTable from '../apps/RepliesTable';
import LineChartSample from '../Chart/LineChartSample';
import ReportingLineChart from '../Chart/ReportingLineChart';

export default function ReportingDashboard() {
    const [isMounted, setIsMounted] = useState(false)
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const custom_user_id = useSelector((state) => state.user.userId);
    const [leadsCount, setLeadsCount] = useState(0)
    const [repliesCount, setRepliesCount] = useState(0)
    const [repeatLeadsCount, setRepeatLeadsCount] = useState(0)
    const [speedToLeadsCount, setSpeedToLeadsCount] = useState(0)
    const [speedToLeadsAverage, setSpeedToLeadsAverage] = useState(0)
    const [oppertunityCount, setOppertunityCount] = useState(0)
    const [preAppsCount, setPreAppsCount] = useState(0)
    const [shoppersCount, setShoppersCount] = useState(0)
    const [repliesConv, setRepliesConv] = useState(0)
    const [oppertunityConv, setOppertunityConv] = useState(0)
    const [preAppsConv, setPreAppsConv] = useState(0)
    const [outboundCall, setOutboundCall] = useState(0)
    const [manualCall, setManualCall] = useState(0)
    const [dialerCall, setDialerCall] = useState(0)
    const [appCount, setAppCount] = useState(0)
    const [creditPulledAppCount, setCreditPulledAppCount] = useState(0)
    const [closedLeadsAppCount, setClosedLeadsAppCount] = useState(0)
    const [openLeadsAppCount, setOpenLeadsAppsCount] = useState(0)
    const [pendingClosingsCount, setPendingClosingsCount] = useState(0)
    const [projectedClosingsCount, setProjectedClosingsCount] = useState(0)

    const [selectedLocations, setSelectedLocations] = useState([]);
    const [selectedCampaigns, setSelectedCampaigns] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const [selectedTeams, setSelectedTeams] = useState([]);
    const [selectedCompanies, setSelectedCompanies] = useState([
    {
        "company_id": 3,
        "name": "Gold Coast Realty"
    },
    {
        "company_id": 10,
        "name": "Supreme Lending"
    },
    {
        "company_id": 6,
        "name": "Vantage Realty Partners"
    },
    {
        "company_id": 4,
        "name": "Homes For Sale Media"
    }
]);
    const [selectedRange, setSelectedRange] = useState({ "id": 1, "name": "DAY" });
    const [selectedChartType, setSelectedChartType] = useState(() => {
        const savedView = localStorage.getItem('chartType');
        return savedView ? JSON.parse(savedView) : "Bar";
    });
    // console.log("selectedChartType", selectedChartType);
    
    const [locations, setLocations] = useState(null)
    const [campaigns, setCampaigns] = useState(null)
    const [users, setUsers] = useState(null)
    const [languages, setLanguages] = useState(null)
    const [teams, setTeams] = useState(null)
    const [companies, setCompanies] = useState(null)
    // console.log("selectedCompanies", selectedCompanies);
    
    const dateRange = [{ "id": 1, "name": "DAY" }, { "id": 2, "name": "MONTH" }]
    const chartTypeOptions = ["Bar", "Line"]
    const [leads, setLeads] = useState([]);
    const generateDateRange = () => {
        const today = new Date();
        const last7thDay = new Date();
        last7thDay.setDate(today.getDate() - 7);

        return [last7thDay, today];
    };
    const [dates, setDates] = useState(() => generateDateRange());
    // const [dates, setDates] = useState(null);
    const [leadsLoading, setLeadsLoading] = useState(true);
    const [chartLabel, setChartLable] = useState([]);
    const [chartLeads, setChartLeads] = useState([]);
    const [chartReplies, setChartReplies] = useState([]);
    const [chartOppertunities, setChartOppertunities] = useState([]);
    const [chartPreApps, setChartPreApps] = useState([]);
    const [chartShoppers, setChartShoppers] = useState([]);
    const [chartOutboundCalls, setChartOutboundCalls] = useState([]);
    const [chartAppLeads, setChartAppLeads] = useState([]);
    const [chartOpenApps, setChartopenApps] = useState([]);
    const [chartClosedApps, setCharClosedApps] = useState([]);

    const [tableVisible, setTableVisible] = useState(false)
    const [repliesTableVisible, setRepliesTableVisible] = useState(false)
    const [repeatLeadsTableVisible, setRepeatLeadsVisible] = useState(false)
    const [speedToLeadsTableVisible, setSpeedToLeadsVisible] = useState(false)
    const [pageLoaded, setPageLoaded] = useState(false)

    const [popupTableData, setpopupTableData] = useState({
        app_count_list: [],
        credit_pulled_app_list: [],
        closed_leads_list: [],
        pending_closings_id_list: [],
        projected_closings_id_list: [],
        open_leads_list: [],
        docs_in_list: [],
        preapps_list: [],
        shoppers_list: [],
        total_replies_id_list: [],
        repeat_leads : [],
        speed_to_leads : []
    })
    const [tableData, setTableData] = useState([])
    const [repliesTableData, setRepliesTableData] = useState([])
    const [repeatLeadsTableData, setRepeatLeadsTableData] = useState([])
    const [speedToLeadsTableData, setSpeedToLeadsTableData] = useState([])
    const [isLineChart, setIsLineChart] = useState(false)
    const [isRepliesLineChart, setIsRepliesLineChart] = useState(false)

    const [popupHeader, setPopupHeader] = useState("")
    const [clickableCard, setClickableCard] = useState(false)
    const [countsDataLoading, setCountsDataLoading] = useState(false)
    const solamonFilters = [
        {
            "user_id": "Ifg74FqfbtWHC95uzhME",
            "name": "John Colatosti",//
            "image": "https://backendapi.homesforsalemedia.com/media/profile_images/462541682_1206161507110449_1426377731865975534_n.png"
        },
        {
            "user_id": "ARisaxpVQPwUnXOco19v",
            "name": "Paul Khoa Do",//
            "image": "https://backendapi.homesforsalemedia.com/media/profile_images/paul-khoa.png"
        },
        {
            "user_id": "wJkbQQbagbU6jrFgfSUl",
            "name": "Chris Erwin",//
            "image": "https://backendapi.homesforsalemedia.com/media/profile_images/chris-erwin.png"
        },
        {
            "user_id": "IswqfTBczfJF7BUOm8pF",
            "name": "Tara Altman",//
            "image": null
        },
        {
            "user_id": "gSV6YhVq2gF8lnsHrzYP",
            "name": "Luke  Riedel",//
            "image": "https://backendapi.homesforsalemedia.com/media/profile_images/Luke_Riedel_Headshot_in_Square-01.png"
        }
    ]

    const ginaFilters = [
        {
            "user_id": "TyvZ8x3ZhG8vzxmDYbk3",
            "name": "Paul Yagual",
            "image": "https://backendapi.homesforsalemedia.com/media/profile_images/Paul_Yagual_cutout_08-2023.png"
        },
        {
            "user_id": "gSV6YhVq2gF8lnsHrzYP",
            "name": "Luke  Riedel",
            "image": "https://backendapi.homesforsalemedia.com/media/profile_images/Luke_Riedel_Headshot_in_Square-01.png"
        },
        {
            "user_id": "Mz480XDOlNyC2jK2FJGm",
            "name": "Lori Schwartz",
            "image": "https://backendapi.homesforsalemedia.com/media/profile_images/Lori_Headshot.png"
        },
        {
            "user_id": "CqhNmmMUuVy1Eq5vHETJ",
            "name": "Danny Wong",
            "image": null
        },
        {
            "user_id": "VyT8UjGuLkODwtlAmHEs",
            "name": "Danielle Petilli",
            "image": null
        },
        {
            "user_id": "vXXIgp7pUDG6Zxl8iwlm",
            "name": "Jason  Hernandez",
            "image": "https://backendapi.homesforsalemedia.com/media/profile_images/profileImage_6qoQL6O.png"
        },
        {
            "user_id": "Ia2ZF3YDNTdmXT77CqgA",
            "name": "Kaivan Gill",
            "image": "https://backendapi.homesforsalemedia.com/media/profile_images/Kaivan_Gill.png"
        },
        {
            "user_id": "aByEKKko89e0DNiTbMez",
            "name": "Lewis Riedel",
            "image": "https://backendapi.homesforsalemedia.com/media/profile_images/lewis.png"
        }
    ]

    // console.log(selectedUsers)

    useEffect(() => {
        if (custom_user_id) {
            axios.post(dashboardFilterData, { custom_user_id: custom_user_id }, {
                headers: { 'Content-Type': 'application/json' },
            })
                .then((response) => {
                    if (response.status === 200) {
                        // console.log(response.data)
                        setLocations(response.data.locations)
                        setCampaigns(response.data.campaigns)
                        setUsers(response.data.users)
                        setLanguages(response.data.languages)
                        setTeams(response.data.teams)
                        setCompanies(response.data.companies)
                        if (custom_user_id == 99) {
                            setSelectedUsers(solamonFilters)
                        } else if (custom_user_id == 87 || custom_user_id == 206) {
                            setSelectedUsers(ginaFilters)
                        }
                        setPageLoaded(true)
                    }
                })
                .catch((error) => {
                    console.log({ error })

                })
        }
    }, [dashboardFilterData, isMounted, custom_user_id])



    useEffect(() => {
        setCountsDataLoading(true)
        if (custom_user_id && (dates === null || (custom_user_id && dates && dates[1] != null))) {
            setLeadsLoading(true);
            const localDates = dates?.map(date => new Date(date.getTime() - date.getTimezoneOffset() * 60000));
            const data = {
                'locations': selectedLocations.map(location => ({ location_id: location.location_id, name: location.name })),
                'campaigns': selectedCampaigns.map(campaign => ({ campaign_id: campaign.campaign_id, name: campaign.name })),
                'users': (custom_user_id == 99 && !pageLoaded) ? solamonFilters : ((custom_user_id == 87 || custom_user_id == 206) && !pageLoaded) ? ginaFilters : selectedUsers.map(user => ({ user_id: user.user_id, name: user.name, image: user.image })),
                'languages': selectedLanguages.map(language => ({ language_id: language.language_id, name: language.name })),
                'teams': selectedTeams.map(team => ({ team_id: team.team_id, name: team.name })),
                'companies': selectedCompanies.map(company => ({ company_id: company.company_id, name: company.name })),
                'date_range': localDates,
                'custom_user_id': custom_user_id,
                'range': selectedRange.name
            }

            axios.post(dashboardReports, data, {
                headers: { 'Content-Type': 'application/json' },
            })
                .then((response) => {
                    if (response.status === 200) {
                        // console.log(response.data)
                        setLeadsCount(response.data.count_data.total_leads)
                        setRepliesCount(response.data.count_data.total_replies)
                        setRepeatLeadsCount(response.data.repeat_leads_count)
                        setSpeedToLeadsCount(response.data.speed_to_leads_count)
                        setSpeedToLeadsAverage(response.data.speed_to_leads_average_readable)
                        setOppertunityCount(response.data.docs_in_count)
                        setPreAppsCount(response.data.preapps_count)
                        setShoppersCount(response.data.shoppers_count)
                        setRepliesConv(response.data.count_data.replies_conv)
                        setOppertunityConv(response.data.count_data.opps_conv)
                        setPreAppsConv(response.data.count_data.preApps_conv)
                        setOutboundCall(response.data.count_data.total_outbount_calls)
                        setManualCall(response.data.count_data.total_manual_calls)
                        setDialerCall(response.data.count_data.total_dialer_calls)
                        setLeads(response.data.leads_data)
                        setChartLable(response.data.chart_data.chart_label)
                        setChartLeads(response.data.chart_data.total_leads_list)
                        setChartReplies(response.data.chart_data.total_replies_list)
                        setChartOppertunities(response.data.chart_data.total_oppertunities_list)
                        setChartPreApps(response.data.chart_data.total_pre_apps_list)
                        setChartShoppers(response.data.chart_data.total_shopper_apps_list)
                        setChartOutboundCalls(response.data.chart_data.total_outbound_call_list)
                        setAppCount(response.data.app_count)
                        setCreditPulledAppCount(response.data.credit_pulled_app_count)
                        setClosedLeadsAppCount(response.data.closed_leads_count)
                        setOpenLeadsAppsCount(response.data.open_leads_count)
                        setPendingClosingsCount(response.data.pending_closings_count)
                        setProjectedClosingsCount(response.data.projected_closings_count)
                        setChartAppLeads(response.data.chart_data.total_app_lead_list)
                        setChartopenApps(response.data.chart_data.total_open_apps_list)
                        setCharClosedApps(response.data.chart_data.total_closed_apps_list)
                        // setDocsInListData(response.data.chart_data.docs_in_list)
                        // console.log("response.data.chart_data", response.data.chart_data)
                        setpopupTableData((prev) => ({
                            ...prev,
                            app_count_list: response.data.app_count_list,
                            credit_pulled_app_list: response.data.credit_pulled_app_list,
                            closed_leads_list: response.data.closed_leads_list,
                            pending_closings_id_list: response.data.pending_closings_id_list,
                            projected_closings_id_list: response.data.projected_closings_id_list,
                            open_leads_list: response.data.open_leads_list,
                            docs_in_list: response.data.docs_in_list,
                            preapps_list: response.data.preapps_list,
                            shoppers_list: response.data.shoppers_list,
                            total_replies_id_list: response.data.total_replies_id_list,
                            repeat_leads : response.data.repeat_leads,
                            speed_to_leads : response.data.speed_to_leads
                        }))
                        setClickableCard(true)
                        setLeadsLoading(false);
                        setCountsDataLoading(false)

                    }
                })
                .catch((error) => {
                    setClickableCard(false)
                    setLeadsLoading(false);
                    setCountsDataLoading(false)
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                })
        } else {
            setClickableCard(false)
            setLeadsLoading(false);
            setCountsDataLoading(false)
        }
    }, [selectedLocations, selectedCampaigns, selectedLanguages, selectedTeams, selectedCompanies, selectedUsers, custom_user_id, dates, selectedRange]);

    useEffect(()=> {
        localStorage.setItem('chartType', JSON.stringify(selectedChartType));
    },[selectedChartType])

    function getInitials(string) {
        let words = string?.split(' ');
        let initials = words?.map(word => word.charAt(0).toUpperCase());
        return initials?.join('');
    }

    const userTemplate = (option) => {
        return (
            <FlexComponent justifyContent="start">
                <Avatar image={option.image} size="small" label={<span style={{ padding: '5px' }}>{getInitials(option?.name)}</span>} shape="circle" style={{ marginRight: '8px' }} />
                <span>{option.name}</span>
            </FlexComponent>
        );
    };

    const headerDialogue = () => {
        return (
            <FlexComponent justifyContent="start" gap="1rem" style={{ padding: ".5rem" }} >
                <div style={{ cursor: "pointer", borderBottom: !isLineChart ? '5px solid white' : 'none', height: "35px" }} onClick={() => {
                    setIsLineChart(false)
                }} >{popupHeader}</div>
                {/* <div style={{cursor: "pointer", borderBottom: isLineChart ? '5px solid white' : 'none', height: "35px"}} onClick={()=> {
                    setIsLineChart(true)
                }} >Line Chart</div> */}
            </FlexComponent>
        );
    }

    const headerRepliesDialogue = () => {
        return (
            <FlexComponent justifyContent="start" gap="1rem" style={{ padding: ".5rem" }} >
                <div style={{ cursor: "pointer", borderBottom: !isRepliesLineChart ? '5px solid white' : 'none', height: "35px" }} onClick={() => {
                    setIsRepliesLineChart(false)
                }} >{popupHeader}</div>
                {/* <div style={{cursor: "pointer", borderBottom: isRepliesLineChart ? '5px solid white' : 'none', height: "35px"}} onClick={()=> {
                    setIsRepliesLineChart(true)
                }} >Line Chart</div> */}
            </FlexComponent>
        );
    }

    //   useEffect(() => {
    //     if (custom_user_id){
    //         const data = {
    //             'locations' : selectedLocations.map(location => ({ location_id: location.location_id, name: location.name })),
    //             'campaigns' : selectedCampaigns.map(campaign => ({ campaign_id: campaign.campaign_id, name: campaign.name })),
    //             'users' : selectedUsers.map(user => ({ user_id: user.user_id, name: user.name })),
    //             'languages' : selectedLanguages.map(language => ({ language_id: language.language_id, name: language.name })),
    //             'custom_user_id': custom_user_id,
    //             'date_range' : dates,
    //         }
    //         setLeadsLoading(true);
    //         axios.post(dashboardLeads, data,{
    //             headers: {'Content-Type': 'application/json' },
    //         })
    //             .then((response) => {
    //                 if (response.status === 200) {
    //                     setLeads(response.data)
    //                     setLeadsLoading(false);             
    //                 }
    //                 })
    //             .catch((error)=>{
    //                 toast.current.show({severity:'error', summary: 'Error', detail:'Something went wrong', life: 3000});          
    //             })
    //     }
    //   }, [selectedLocations, selectedCampaigns, selectedLanguages, selectedUsers, custom_user_id, dates]);

    const syncHandle = () => {
        setLoading(true);
        axios.get(syncLocations_v2, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setIsMounted(!isMounted)
                    setLoading(false);
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                setLoading(false);
            })
    }


    return (
        <div className='reportingDashboardContainer' >
            <Toast ref={toast} />
            <FlexComponent className="dashboardTopFilterContainer" justifyContent="end" gap="2rem" >

                <div className='sync-button-container ' style={{ width: "200px" }}>
                    <span className="p-float-label filter-card-container" >
                        <MultiSelect value={selectedTeams} filter onChange={(e) => setSelectedTeams(e.value)} options={teams} optionLabel="name" maxSelectedLabels={1} className="w-full md:w-20rem full-width" />
                        <label htmlFor="ms-cities">Select Teams</label>
                    </span>
                </div>

                <div className='sync-button-container' style={{ width: "200px" }}>
                    <span className="p-float-label filter-card-container">
                        <MultiSelect value={selectedCompanies} filter onChange={(e) => setSelectedCompanies(e.value)} options={companies} optionLabel="name" maxSelectedLabels={1} className="w-full md:w-20rem full-width" />
                        <label htmlFor="ms-cities">Select Companies</label>
                    </span>
                </div>

                <div className='sync-button-container ' >
                    <Button className='sync-button filter-card-container' label="Sync" icon="pi pi-sync" onClick={syncHandle} />
                </div>
            </FlexComponent>

            {loading && (
                <div className="overlay">
                    <i className="pi pi-spin pi-spinner " style={{ fontSize: '2rem' }}></i>
                </div>
            )}

            <div className='dashboard-filter-container'>
                <span className="p-float-label filter-card-container">
                    <MultiSelect value={selectedLocations} filter onChange={(e) => setSelectedLocations(e.value)} options={locations} optionLabel="name" maxSelectedLabels={1} className="w-full md:w-20rem full-width" />
                    <label htmlFor="ms-cities">Select Locations</label>
                </span>

                <span className="p-float-label filter-card-container">
                    <MultiSelect value={selectedCampaigns} filter onChange={(e) => setSelectedCampaigns(e.value)} options={campaigns} optionLabel="name" maxSelectedLabels={1} className="w-full md:w-20rem full-width" />
                    <label htmlFor="ms-cities">Select Campaigns</label>
                </span>

                <span className="p-float-label filter-card-container">
                    <MultiSelect value={selectedUsers} filter onChange={(e) => setSelectedUsers(e.value)} options={users} itemTemplate={userTemplate} optionLabel="name" maxSelectedLabels={1} className="w-full md:w-20rem full-width" />
                    <label htmlFor="ms-cities">Select Users</label>
                </span>

                <span className="p-float-label filter-card-container">
                    <MultiSelect value={selectedLanguages} filter onChange={(e) => setSelectedLanguages(e.value)} options={languages} optionLabel="name" maxSelectedLabels={1} className="w-full md:w-20rem full-width" />
                    <label htmlFor="ms-cities">Select Languages</label>
                </span>



                <span className="p-float-label filter-card-container">
                    <Calendar value={dates} onChange={(e) => setDates(e.value)} selectionMode="range" className="full-width" />
                    <label htmlFor="ms-cities" className='dateRangelabel'>Select Date Range</label>
                </span>
            </div>

            <div className='dashboard-card-container'>
                <div className="dash-card-container flex justify-content-center">
                    <Card title="Leads" subTitle={<div>{!countsDataLoading ? <div>{leadsCount}</div> : <Button style={{ background: "transparent", transform: "scale(1.8)" }} loading={true} />}</div>}
                        className="md:w-25rem dashboard-card leads-card">
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Repeat Leads" style={{ pointerEvents: repeatLeadsCount && clickableCard ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setRepeatLeadsVisible(true)
                        setPopupHeader("Total Repeat Leads")
                        setRepeatLeadsTableData(popupTableData.repeat_leads)
                    }} subTitle={<div>{!countsDataLoading ? <div>{repeatLeadsCount}</div> : <Button style={{ background: "transparent", transform: "scale(1.8)" }} loading={true} />}</div>}
                        className="md:w-25rem dashboard-card replies-card">
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center" style={{minWidth: "100px"}}>
                    <Card title="Speed To Leads" style={{ pointerEvents: speedToLeadsCount && clickableCard ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setSpeedToLeadsVisible(true)
                        setPopupHeader("Total Spead To Leads")
                        setSpeedToLeadsTableData(popupTableData.speed_to_leads)
                    }} subTitle={<div>{!countsDataLoading ? <div>{speedToLeadsCount}</div> : <Button style={{ background: "transparent", transform: "scale(1.8)" }} loading={true} />}</div>}
                        className="md:w-25rem dashboard-card replies-card">
                        <div style={{fontSize: "12px"}} className="dashboard-percentage">{!countsDataLoading ? <div>{`${speedToLeadsAverage || ""}`}</div> : <Button label='' style={{ background: "transparent", color: "white" }} loading={true} />}</div>
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Replies" style={{ pointerEvents: repliesCount && clickableCard ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setRepliesTableVisible(true)
                        setPopupHeader("Total Replies")
                        setRepliesTableData(popupTableData.total_replies_id_list)
                    }} subTitle={<div>{!countsDataLoading ? <div>{repliesCount}</div> : <Button style={{ background: "transparent", transform: "scale(1.8)" }} loading={true} />}</div>}
                        className="md:w-25rem dashboard-card replies-card">
                        <div className="dashboard-percentage">{!countsDataLoading ? <div>{`${repliesConv}%`}</div> : <Button label='%' style={{ background: "transparent", color: "white" }} loading={true} />}</div>
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Calls" subTitle={<div>{!countsDataLoading ? <div>{outboundCall}</div> : <Button style={{ background: "transparent", transform: "scale(1.8)" }} loading={true} />}</div>}
                        className="md:w-25rem dashboard-card call-card">
                        <span className="dashboard-percentage" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '.5rem' }}>
                            <p>Manual</p>
                            <div>{<div>{!countsDataLoading ? <div>{manualCall}</div> : <Button style={{ background: "transparent", padding: "0px", fontSize: ".5rem" }} loading={true} />}</div>}</div>
                        </span>
                        <span className="dashboard-percentage" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '.5rem' }}>
                            <p>Dialer</p>
                            <div>{<div>{!countsDataLoading ? <div>{dialerCall}</div> : <Button style={{ background: "transparent", padding: "0px", fontSize: ".5rem" }} loading={true} />}</div>}</div>
                        </span>
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Apps" style={{ pointerEvents: appCount && clickableCard ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total Apps")
                        setTableData(popupTableData.app_count_list)
                    }} subTitle={<div>{!countsDataLoading ? <div>{appCount}</div> : <Button style={{ background: "transparent", transform: "scale(1.8)" }} loading={true} />}</div>} className="md:w-25rem dashboard-card app-card">
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Docs In" style={{ pointerEvents: oppertunityCount && clickableCard ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total Docs In")
                        setTableData(popupTableData.docs_in_list)
                    }} subTitle={<div>{!countsDataLoading ? <div>{oppertunityCount}</div> : <Button style={{ background: "transparent", transform: "scale(1.8)" }} loading={true} />}</div>} className="md:w-25rem dashboard-card opp-card">
                        {/* <p className="dashboard-percentage">{`${oppertunityConv}%`}</p> */}
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Credit Pulled" style={{ pointerEvents: creditPulledAppCount && clickableCard ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total Credit Pulled")
                        setTableData(popupTableData.credit_pulled_app_list)
                    }} subTitle={<div>{!countsDataLoading ? <div>{creditPulledAppCount}</div> : <Button style={{ background: "transparent", transform: "scale(1.8)" }} loading={true} />}</div>} className="md:w-25rem dashboard-card app-card">
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="PreApps" style={{ pointerEvents: preAppsCount && clickableCard ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total PreApps")
                        setTableData(popupTableData.preapps_list)
                    }} subTitle={<div>{!countsDataLoading ? <div>{preAppsCount}</div> : <Button style={{ background: "transparent", transform: "scale(1.8)" }} loading={true} />}</div>}
                        className="md:w-25rem dashboard-card pre-card">
                        {/* <p className="dashboard-percentage">{`${preAppsConv}%`}</p> */}
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Shoppers" style={{ pointerEvents: shoppersCount && clickableCard ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total Shoppers")
                        setTableData(popupTableData.shoppers_list)
                    }} subTitle={<div>{!countsDataLoading ? <div>{shoppersCount}</div> : <Button style={{ background: "transparent", transform: "scale(1.8)" }} loading={true} />}</div>}
                        className="md:w-25rem dashboard-card shoppers-card">
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Open" style={{ pointerEvents: openLeadsAppCount && clickableCard ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total Open Deals")
                        setTableData(popupTableData.open_leads_list)
                    }} subTitle={<div>{!countsDataLoading ? <div>{openLeadsAppCount}</div> : <Button style={{ background: "transparent", transform: "scale(1.8)" }} loading={true} />}</div>} className="md:w-25rem dashboard-card app-card">
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Closed" style={{ pointerEvents: closedLeadsAppCount && clickableCard ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total Closed Deals")
                        setTableData(popupTableData.closed_leads_list)
                    }} subTitle={<div>{!countsDataLoading ? <div>{closedLeadsAppCount}</div> : <Button style={{ background: "transparent", transform: "scale(1.8)" }} loading={true} />}</div>} className="md:w-25rem dashboard-card app-card">
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Projections" style={{ pointerEvents: closedLeadsAppCount && clickableCard ? "all" : "none" }}
                        // subTitle={<div>{!countsDataLoading ? <div>{closedLeadsAppCount}</div> : <Button style={{ background: "transparent", transform: "scale(1.8)" }} loading={true} />}</div>}
                        className="md:w-25rem dashboard-card app-card">
                        <FlexComponent gap=".25rem" >
                            <span className="dashboard-percentage"
                                onClick={() => {
                                    setTableVisible(true)
                                    setPopupHeader("Total Pending Closings")
                                    setTableData(popupTableData.pending_closings_id_list)
                                }}
                                style={{ pointerEvents: pendingClosingsCount && clickableCard ? "all" : "none", cursor: "pointer", display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '.5rem' }}>
                                <p>Pending Closings</p>
                                <div>{<div>{!countsDataLoading ? <div style={{ fontSize: "1.5rem" }} >{pendingClosingsCount}</div> : <Button style={{ background: "transparent", padding: "0px", fontSize: "1.5rem" }} loading={true} />}</div>}</div>
                            </span>
                            {/* <div style={{width: "1px", background: "grey", minHeight: "70px"}} ></div> */}
                            <span className="dashboard-percentage"
                                onClick={() => {
                                    setTableVisible(true)
                                    setPopupHeader("Total Projected Closings")
                                    setTableData(popupTableData.projected_closings_id_list)
                                }}
                                style={{ pointerEvents: projectedClosingsCount && clickableCard ? "all" : "none", cursor: "pointer", display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '.5rem' }}>
                                <p>Projected Closings</p>
                                <div>{<div>{!countsDataLoading ? <div style={{ fontSize: "1.5rem" }} >{projectedClosingsCount}</div> : <Button style={{ background: "transparent", padding: "0px", fontSize: "1.5rem" }} loading={true} />}</div>}</div>
                            </span>
                        </FlexComponent>
                    </Card>
                </div>

                <AppModal visible={tableVisible} onHide={() => setTableVisible(false)} header={headerDialogue()} panelStyle={{ width: '90vw', minHeight: '70vh' }}>
                    <div>
                        {!isLineChart && tableData?.length > 0 && <AppsTable popupHeader={popupHeader} userId={custom_user_id} countsIds={tableData} />}
                        {isLineChart && <LineChartSample />}
                    </div>
                </AppModal>

                <AppModal visible={repliesTableVisible} onHide={() => setRepliesTableVisible(false)} header={headerRepliesDialogue()} panelStyle={{ width: '90vw' }}>
                    <div>
                        {!isRepliesLineChart && repliesTableData?.length > 0 && <RepliesTable userId={custom_user_id} countsIds={repliesTableData} />}
                        {isRepliesLineChart && <LineChartSample />}
                    </div>
                </AppModal>

                <AppModal visible={repeatLeadsTableVisible} onHide={() => setRepeatLeadsVisible(false)} header={headerRepliesDialogue()} panelStyle={{ width: '90vw' }}>
                    <div>
                        {repeatLeadsTableData?.length > 0 && <LeadsTable leads={repeatLeadsTableData} loading={leadsLoading} isRepeatLeads={true} />}
                        {/* {isRepliesLineChart && <LineChartSample />} */}
                    </div>
                </AppModal>

                <AppModal visible={speedToLeadsTableVisible} onHide={() => setSpeedToLeadsVisible(false)} header={headerRepliesDialogue()} panelStyle={{ width: '90vw' }}>
                    <div>
                        {speedToLeadsTableData?.length > 0 && <LeadsTable leads={speedToLeadsTableData} loading={leadsLoading} isRepeatLeads={false} isSpeedToLeads={true} />}
                        {/* {isRepliesLineChart && <LineChartSample />} */}
                    </div>
                </AppModal>

            </div>

            <div style={{ marginTop: '4rem' }}>
                <FlexComponent justifyContent="end" gap="1rem" >
                    <span >
                        <Dropdown value={selectedChartType} onChange={(e) => setSelectedChartType(e.value)} options={chartTypeOptions} 
                            placeholder="Type" className="w-full md:w-14rem" style={{ width: "130px", marginBottom: "1rem" }} />
                    </span>
                    <span >
                        <Dropdown value={selectedRange} onChange={(e) => setSelectedRange(e.value)} options={dateRange} optionLabel="name"
                            placeholder="Select a Range" className="w-full md:w-14rem" style={{ width: "135px", marginBottom: "1rem" }} />
                    </span>
                </FlexComponent>
                {selectedChartType === "Bar" ? <ChartJs label={chartLabel} leads={chartLeads} replies={chartReplies} oppertunities={chartOppertunities} preApps={chartPreApps} shoppers={chartShoppers} outboundCalls={chartOutboundCalls} chartAppLeads={chartAppLeads} chartOpenApps={chartOpenApps} chartClosedApps={chartClosedApps} loading={leadsLoading} />
                    : <ReportingLineChart label={chartLabel} leads={chartLeads} replies={chartReplies} oppertunities={chartOppertunities} preApps={chartPreApps} shoppers={chartShoppers} outboundCalls={chartOutboundCalls} chartAppLeads={chartAppLeads} chartOpenApps={chartOpenApps} chartClosedApps={chartClosedApps} loading={leadsLoading} />
                }
            </div>

            <div style={{ marginTop: '4rem', marginBottom: '2rem' }}>
                <LeadsTable leads={leads} loading={leadsLoading} />
            </div>
        </div>
    )
}